import PropTypes from 'prop-types';

import { DSIcon } from '@spotahome/ui-library/base';

import './GalleryArrow.scss';

const GalleryNavigator = ({ navRole, onClick }) => (
  <div
    className={`gallery-arrow gallery-arrow--${navRole}`}
    onClick={onClick}
    role="button"
    tabIndex="0"
  >
    <DSIcon
      name={navRole === 'prev' ? 'arrow_full_left' : 'arrow_full_right'}
      size="xl"
    />
  </div>
);

GalleryNavigator.propTypes = {
  navRole: PropTypes.oneOf(['next', 'prev']).isRequired,
  onClick: PropTypes.func.isRequired
};

export default GalleryNavigator;
